<div class="forgot-pass-container bg-light forgotPassword" id="divForgot">
  <div class="forgot-pass-box">
    <div class="pt-4">
      <div class="d-inline-block ml-3">
        <app-language-selector></app-language-selector>
      </div>
    </div>
    <h1 translate>{{ 'Forgot password' | translate }}</h1>
    <div class="container">
      <div class="card col-md-6 col-xl-5 mt-3 mx-auto">
        <div class="card-body">
          <form (ngSubmit)="onSubmit()" [formGroup]="forgotPassForm" novalidate>
            <div class="#">
              <label for="email" class="d-block"
                ><b>{{ 'Email ID' | translate }}</b></label
              >
              <input
                type="email"
                class="form-control"
                placeholder="{{ 'Enter Email' | translate }}"
                formControlName="email"
                id="email"
                required
              />
              <small
                [hidden]="forgotPassForm.controls.email.valid || forgotPassForm.controls.email.untouched"
                class="text-danger"
              >
                {{ 'Valid Email' | translate }}
              </small>
            </div>
            <div class="top-margin">
              <button class="btn btn-primary w-30" type="submit" [disabled]="forgotPassForm.invalid">
                <i class="fas fa-cog fa-spin" [hidden]="!isLoading"></i>
                <span translate>{{ 'Reset Password' | translate }}</span>
              </button>
              <button class="btn btn-primary w-30 float-right" type="cancel">
                <span translate (click)="goBack()">{{ 'Cancel' | translate }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<p-blockUI #divForgot [blocked]="blocked">
  <i class="pi pi-circle" style="font-size: 3rem"></i>
</p-blockUI>
<p-toast position="top-center" key="forgot"></p-toast>
<p-toast position="top-center" key="c" style="display: block" (onClose)="onReject()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center info">
        <!-- <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i> -->
        <p class="m-0">{{ confirmMessage }}</p>
        <p class="m-0">{{ confirmMessageSummary }}</p>
      </div>
      <div>
        <div class="p-text-center">
          <p-button label="OK" (click)="onReject()" styleClass="p-button-text"></p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
